export type UseGoogleAdsSettingsProps = {
  enabled: boolean;
  slug: string
}

const versions = {
  opopular: '2.7',
  tocantins: '2.1',
  daqui: '2.1'
}

export function useGoogleAdsSettings({ enabled, slug }: UseGoogleAdsSettingsProps) {
  if (!enabled) {
    return <></>
  }

  return (
    <>
      <script
        async
        key='google-ads-settings'
        type='text/javascript'
        src={`/scripts/ads-slots-settings-${slug}.js?v=${versions[slug]}`}
      />
    </>
  )
}
